module.exports = __webpack_public_path__ + "media/images/we_remember_journeys/weremember-logo-4bc74f87e842d7fff54c25d96dc0eaf6.svg";